import React, { useEffect } from 'react';
import lussagif from './images/lussa.gif';
import { SectionTerminal } from './SectionTerminal';
import { ParticleCanvas } from './ParticleCanvas';

export function SectionParallaxBody() {
  useEffect(() => {
    function handleScrollY() {
      const distance = window.scrollY;
      document.querySelector(".container").style.transform = `translate(0px, ${distance * 0.6}px)`;
    }

    document.addEventListener("scroll", handleScrollY);
    return () => document.removeEventListener("scroll", handleScrollY);
  }, []);

  return (
    <main>
      <div className="sectionone">
        <ParticleCanvas />
        <div className="container">
          <img src={lussagif} className="lussasign" alt="" />
        </div>
      </div>
      <div className="sectiontwo">
        {<SectionTerminal />}
      </div>
    </main>
  );
}
